import React from 'react';
import { Smartphone, Globe, Monitor, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import AppImg from '../assets/img/Services/Wireless_Mobile_Applications.jpg';
import WebImg from '../assets/img/Services/WebTechnologies.jpg';
import DesktopImg from '../assets/img/Services/Software_Design.jpg';

const ServiceHighlights: React.FC = () => {
  const highlights = [
    {
      title: 'Mobile App Development',
      description: 'Custom iOS and Android solutions that provide seamless user experiences and robust performance.',
      icon: <Smartphone size={32} className="text-gradient" />,
      image: AppImg,
      link: '/services/wireless-mobile'
    },
    {
      title: 'Web Development',
      description: 'Modern, responsive, and scalable web applications built with the latest technologies like React, Node, and more.',
      icon: <Globe size={32} className="text-gradient" />,
      image: WebImg,
      link: '/services/web-technologies'
    },
    {
      title: 'Desktop Application',
      description: 'Powerful desktop software tailored for enterprise needs, ensuring high security and local performance.',
      icon: <Monitor size={32} className="text-gradient" />,
      image: DesktopImg,
      link: '/services/software-design'
    }
  ];

  return (
    <section className="service-highlights-section" style={{ padding: '80px 0' }}>
      <div className="shell">
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div className="badge-pill" style={{ marginBottom: '15px' }}>Our Core Services</div>
          <h2 className="section-title">We Build <span className="text-gradient">Everything</span></h2>
          <p className="section-subtitle">From mobile screens to enterprise desktop systems, we make IT happen.</p>
        </div>

        <div className="grid-layout">
          {highlights.map((item, index) => (
            <article key={item.title} className={`feature-card fade-in-up`} style={{ animationDelay: `${index * 0.2}s`, padding: '0', overflow: 'hidden' }}>
              <div style={{ height: '200px', overflow: 'hidden' }}>
                <img src={item.image} alt={item.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div style={{ padding: '30px' }}>
                <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div className="icon-wrapper" style={{ background: 'var(--bg-glass)', padding: '10px', borderRadius: '12px' }}>
                    {item.icon}
                  </div>
                  <h3 style={{ margin: '0', fontSize: '20px' }}>{item.title}</h3>
                </div>
                <p style={{ color: 'var(--text-secondary)', fontSize: '14px', lineHeight: '1.6', marginBottom: '20px' }}>
                  {item.description}
                </p>
                <Link to={item.link} className="text-link" style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600', color: 'var(--accent)' }}>
                  Learn More <ArrowRight size={16} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceHighlights;
